<script setup lang="ts">
import type { Campaign } from "#shared/utils/campaign";

definePageMeta({
  name: "products",
});

const version = useCrystallizeVersion();

const { time } = useServerTiming();

const { data: campaign } = useQuery<Campaign | null>({
  queryKey: ["campaign", "aunivers", version],
  staleTime: 1000 * 60 * 60,
  queryFn: async () => {
    const data = await time("GetAuniversCampaign", () =>
      $crystallizeFetch({
        document: "page",
        path: "/kampanjer/aunivers",
        version: useCrystallizeVersion(),
      }));

    return toCampaign(data.catalogue);
  },
});

const { data: productCatalogue, suspense } = useProducts();

await suspense();

const products = computed(() => {
  const all = productCatalogue.value?.map(toProductCard) ?? [];

  return [...all].sort((a, b) => {
    if (a.type === b.type) {
      return 0;
    }

    if (isPacket(a)) {
      return -1;
    }

    return 1;
  });
});

const route = useRoute();

const filtered = computed(() => {
  const filters = route.query;

  return products.value
    .filter(byLevels(filters))
    .filter(bySubjects(filters))
    .filter(byFormats(filters))
    .sort(byTypeAndLevel);
});

useHead({
  bodyAttrs: {
    class: "bg-green-10",
  },
});
</script>

<template>
  <div>
    <LayoutBreadCrumbs :background="true" />
    <UContainer
      id="main-content"
      as="main"
      class="mb-20 flex flex-col justify-center self-center"
      aria-labelledby="page-title"
    >
      <h1 id="page-title" class="mt-16 mb-3 text-center font-headline text-3xl font-normal text-green-50 xs:mb-4 xs:text-left xs:text-5xl tablet:mb-6 tablet:text-6xl">
        Finn læremidler
      </h1>
      <UiProductsCatalogFilter :products="products" />
      <UiCampaignCallout class="mx-auto mb-8" :campaign="campaign" />
      <UiProductsCatalog :products="filtered" />
    </UContainer>
  </div>
</template>
